<template>
  <modal
    name="pro-project-details-modal"
    height="auto"
    classes="project-viewer-modal"
    width="90%"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="$emit('modalClose')">
    <div v-if="project" class="">
      <div class="">
        <div class="pa0 ma0">
          <div class="flex flex-wrap br4 bg-white">
            <!-- Left Column -->
            <div class="order-2 items-center order-1-ns tc w-100 w-60-m w-75-ns bg-near-black pr3-ns overflow-y-scroll-ns">
              <div v-for="medium in project.media" :key="medium.filePath">
                <img v-if="medium.type == 'IMAGE'" :src="env.projectMediaUrl + medium.filePath + '?auto=compress'" class="w-100" />
                <div v-if="medium.type == 'YOUTUBE_VIDEO'" class="bg-near-black w-100 dt vh-100">
                  <youtube player-width="100%" :video-id="getYouTubeId(medium.filePath)" class="dtc v-mid"></youtube>
                </div>
                <div v-if="medium.type == 'VIMEO_VIDEO'" class="bg-near-black w-100 dt">
                    <vimeo-player
                        :video-id="getVimeoId(medium.filePath)"
                    />
                </div>
              </div>
            </div>
            <!-- Right Column -->
            <div class="v-top bg-white order-1 order-2-ns w-100 w-40-m w-25-ns bg-white pa4 overflow-y-scroll-ns">
              <div class="flex justify-between">
                <div v-if="project.id">
                  <div v-if="project.creator.proProfileCreated" class="ma0 pa0">
                    <pro-project-reaction-form
                        :project-id="project.id"
                        :creator-id="project.creator.id"
                    />
                    <span class="ml2 ba f4 gray pa2 gray br2 b--black-10 bg-animate hover-bg-near-white cursor" @click="copyProjectLinkToClipboard">{{copyProjectUrlButtonText}}</span>
                  </div>
                </div>
                <!-- new project creation -->
                <div v-if="previewMode && !project.id">
                  <div class="ma0 pa0">
                    <a>
                      <span class="ba f4 pa2 br2 b--black-10 bg-animate hover-bg-near-white cursor">
                          <span class="gray">0</span>
                          &heartsuit;
                      </span>
                    </a>
                    <span class="ml2 ba f4 gray pa2 gray br2 b--black-10 bg-animate hover-bg-near-white cursor">{{copyProjectUrlButtonText}}</span>
                  </div>
                </div>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" @click="$modal.hide('pro-project-details-modal')" class="cursor fr pa1">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1422 13.0208L25.3952 2.76777L23.2739 0.646448L13.0209 10.8995L2.7678 0.64645L0.646484 2.76777L10.8995 13.0208L0.646484 23.2739L2.7678 25.3952L13.0209 15.1421L23.2739 25.3952L25.3952 23.2739L15.1422 13.0208Z" fill="#999999"/>
                </svg>
              </div>
              <!-- Render Pro name and title -->
              <div class="flex items-center pv4">
                <div class="w-25">
                  <a :href="proProfileLink" :target="profileLinkTarget">
                    <img v-if="project.creator.profilePicture" :src="env.userMediaUrl + project.creator.profilePicture +'?w=610&h=568&dpr=2&q=50&crop=fit&mask=ellipse&faceindex=1&fit=facearea&facepad=2'" class="br-100" alt="Pro">
                    <!--TODO: add placeholder image for case creator has no profile pic-->
                    <img v-if="!project.creator.profilePicture" src="/img/default-avatar.png" class="br-100" alt="Pro">
                  </a>
                </div>
                <div class="w-75 pl3">
                  <a :href="proProfileLink" :target="profileLinkTarget">
                    <h2 class="f3 mv1 lh-title near-black">{{project.creator.fullName}}</h2>
                    <p class="f3 mv1 near-black lh-copy">{{project.creator.jobTitle}}</p>
                    <div class="flex items-center pv2">
                      <img src="/img/location-icon.svg" alt="Location">
                      <p class="near-black lh-copy f4 mv0 pv0 pl2">{{project.creator.livesIn}}</p>
                    </div>
                  </a>
                </div>
              </div>
              <h1 class="f3">{{project.name}}</h1>
              <div class="pv3">
                <p class="lh-copy f4">{{project.description}}</p>
              </div>
              <h2 class="f3">Project Location</h2>
              <div class="flex items-center">
                <img src="/img/location-icon.svg" alt="Location">
                <p class="near-black lh-copy f4 mv0 pv0 pl2">{{project.addressLookupLocation}}</p>
              </div>
              <!-- Render collaborators, if present -->
              <div v-if="project.collaborators.length > 0" class="pv3">
                <h3 class="f3">Collaborators</h3>
                <div v-for="collaborator in project.collaborators">
                  <div class="flex pv2">
                    <div class="w-10">
                      <a v-if="collaborator.userId" :href="'/pro/profile/' + collaborator.userId">
                        <img v-if="!collaborator.profilePicture" src="/img/default-avatar.svg" alt="proUser default picture">
                        <img v-if="collaborator.profilePicture" :src="env.userMediaUrl + collaborator.profilePicture + '?w=120&h=120&dpr=2&fit=crop&q=50&mask=ellipse&faceindex=1&fit=facearea&facepad=2&maskbg=FFFFFF'" alt="proUser default picture">
                      </a>
                      <img v-if="!collaborator.userId && collaborator.profilePicture" :src="env.userMediaUrl + collaborator.profilePicture + '?w=120&h=120&dpr=2&fit=crop&q=50&mask=ellipse&faceindex=1&fit=facearea&facepad=2&maskbg=FFFFFF'" alt="proUser default picture">
                      <img v-if="!collaborator.userId && !collaborator.profilePicture" src="/img/default-avatar.svg" alt="proUser default picture">
                    </div>
                    <div class="w-90 pl3">
                      <h2 class="f4 mv1">{{collaborator.name}}</h2>
                      <p class="f5 mv1 silver">{{collaborator.projectRole}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Render Tags -->
              <div class="pv3">
                <h3 class="f3">Tags</h3>
                <div v-for="tag in project.tags" class="dib bg-white pa2 lh-copy ph3 br-pill ba b--black-10 f5 ma1">{{tag.id}}</div>
              </div>
              <!-- Render Space Card if one exists -->
              <div v-if="project.space && project.space.firstSpaceMediaImagePath">
                <h3 class="f3">Project Space</h3>
                <div class="mt4">
                  <div class="br2 w-100 bg-white shadow-1">
                    <a :href="'/space/' + project.space.id" target="_blank">
                      <img class="w-100 br--top br2" :src="env.spaceMediaUrl + project.space.firstSpaceMediaImagePath + '?w=610&amp;h=408&amp;dpr=2&amp;fit=crop&amp;q=50'" :alt="project.space.description"/>
                    </a>
                    <div class="flex pt3">
                      <div class="w-75 dtc pl3">
                        <div class="dtc w-100">
                          <h2 class="ma0 f4 f3-l pl3 pl0-ns" :href="'/space/' + project.space.id">{{project.space.description}}</h2>
                          <p class="f4 pv1 black-50 pl3 pl0-ns" :href="'/space/' + project.space.id">{{project.space.city + ',' + project.space.state}}</p>
                        </div>
                      </div>
                      <div class="w-25">
                        <p class="f5 b pa0 ma0 black-50">From:</p>
                        <p class="b black-80 f5 f4-l">$<span>{{project.space.minimumRate}}</span>/hr</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showEditBtn" class="pv4">
                <div class="flex w-100 items-center">
                  <p>
                    <a :href="'/pro/project/' + project.id + '/?form'" class="bg-near-white gray hover-gray f5 fw6 br2 pa3">Edit project</a>
                  </p>
                  <p class="help v-base ma0 ph3" v-tooltip="'Only signed in project owners will see this button'">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="7.5" stroke="#999999"/>
                      <path d="M5.45703 5.93555H7.04492C7.08008 5.29102 7.52539 4.875 8.19922 4.875C8.86719 4.875 9.3125 5.26172 9.3125 5.80664C9.3125 6.35156 9.08398 6.63281 8.32812 7.08398C7.51953 7.55859 7.19727 8.08594 7.27344 9.02344L7.28516 9.3457H8.83789V9.03516C8.83789 8.47266 9.05469 8.18555 9.83398 7.73438C10.6602 7.24805 11.0879 6.63281 11.0879 5.75391C11.0879 4.40039 9.98047 3.46875 8.30469 3.46875C6.50586 3.46875 5.48633 4.47656 5.45703 5.93555ZM8.12305 12.1758C8.7793 12.1758 9.18359 11.7949 9.18359 11.1797C9.18359 10.5586 8.7793 10.1777 8.12305 10.1777C7.4668 10.1777 7.05664 10.5586 7.05664 11.1797C7.05664 11.7949 7.4668 12.1758 8.12305 12.1758Z" fill="#999999"/>
                    </svg>
                  </p>
                </div>
              </div>
              <div v-if="project.creator.proProfileCreated" class="social ph4 pt4 ph0-ns">
                <a class="mh1 resp-sharing-button__link" :href="`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(viewProjectUrl)}`" target="_blank" aria-label="">
                  <img src="/img/pro-add-facebook.svg" alt="Facebook">
                </a>
                <a class="mh1 resp-sharing-button__link" :href="`https://twitter.com/intent/tweet/?text=AVVAY%20Pro&amp;url=${encodeURIComponent(viewProjectUrl)}`" target="_blank" aria-label="">
                  <img src="/img/pro-add-twitter.svg" alt="Twitter">
                </a>
                <a class="mh1 resp-sharing-button__link" :href="`https://www.tumblr.com/widgets/share/tool?posttype=link&&amp;content=${encodeURIComponent(viewProjectUrl)}&amp;canonicalUrl=http%3A%2F%2Favvay.com&amp;shareSource=tumblr_share_button`" target="_blank" aria-label="">
                  <img src="/img/pro-add-tumblr.svg" alt="Tumblr">
                </a>
                <a class="mh1 resp-sharing-button__link" :href="`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(viewProjectUrl)}&amp;media=${encodeURIComponent(viewProjectUrl)}&amp;summary=AVVAY%20Pro`" target="_blank" aria-label="">
                  <img src="/img/pro-add-pinterest.svg" alt="Pinterest">
                </a>
              </div>
              <!--End Social-->
              <p class="f5 mv4">
                <a href="mailto:support@avvay.com?subject=AVVAY Pro Project Report&body=Hi, I would like to report this project."
                class="link silver hover-gray cursor">
                  <svg id="i-flag" class="v-mid" viewBox="0 0 32 32" width="16" height="16" fill="none" stroke="#ccc" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="6.25%">
                    <path d="M6 2 L6 30 M6 6 L26 6 20 12 26 18 6 18" />
                  </svg> Report this page</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>

import Vue from "vue"
import VModal from 'vue-js-modal'
import VueYouTubeEmbed, {getIdFromURL, YouTubePlayer} from "vue-youtube-embed";
import { mapState } from 'vuex'
import VimeoPlayer from './VimeoPlayer';
import VueClipboard from 'vue-clipboard2'
import ProProjectReactionForm from './ProProjectReactionForm';

Vue.use(VModal);
Vue.use(VueYouTubeEmbed, {global: false});
Vue.use(VueClipboard);

export default {
    name: 'ProProjectDetailsModal',
    components: { youtube: YouTubePlayer, ProProjectReactionForm, VimeoPlayer },
    props: {
        profileLinkTarget: {
            type: String,
            default: '_self',
            required: false,
        }
    },
    computed: {
        ...mapState(['currentUser', 'env']),
        showEditBtn: function() {
            return !this.previewMode && this.currentUser.id && +this.currentUser.id === this.project.creator.id
        },
        viewProjectUrl: function() {
            const projectPath = `/pro/profile/${this.project.creator.id}?projectId=${this.project.id}`;
            const portPart = window.location.port ? `:${window.location.port}` : '';
            const projectUrl = `${window.location.protocol}//${window.location.hostname}${portPart}${projectPath}`;
            return projectUrl;
        },
        proProfileLink : function() {
            const profileLink = `/pro/profile/${this.project.creator.id}`;
            const noProfileLink = 'javascript:void(0)';

            return this.project.creator.proProfileCreated ? profileLink : noProfileLink

        }
    },
    data() {
        return {
            project: null,
            previewMode: false,
            copyProjectUrlButtonText: 'Copy Link',
        }
    },

    methods: {
        /**
         * per https://github.com/euvl/vue-js-modal, way to initialize modal with data
         * @param event
         */
        beforeOpen (event) {
            this.project = event.params.project;
            this.previewMode = event.params.previewMode;
        },
        getYouTubeId(url){
            let vid = null;
            if(!_.isNil(url)){
                let foundVid = getIdFromURL(url);

                // unparsable urls will just equal the entered videoUrl for some reason
                if(!_.isEqual(url, foundVid) && !_.isNil(foundVid)){
                    vid = foundVid;
                }
            }

            return vid;
        },
        getVimeoId(url) {
            if (!_.isNil(url)) {
                const baseUrl = url.split('?')[0];
                const parts = baseUrl.split('/');
                const id = Number(parts[parts.length - 1]);
                if (!_.isNaN(id)) {
                    return id;
                }
            }
            return null;
        },
        copyProjectLinkToClipboard(){
            this.$copyText(this.viewProjectUrl).then((e) => {
                this.copyProjectUrlButtonText = 'Link Copied!';
                setTimeout(() => this.copyProjectUrlButtonText = 'Copy Link', 2000);
            });
        }
    },

    mounted() {
        document.addEventListener("keydown", (e) => {
            if (this.show && e.keyCode === 27) {
                this.close();
            }
        });
    }
}
</script>

<style scoped>

.v--modal-overlay[data-modal="size-modal"] {
    background: rgba(0, 0, 0, 1);
  }

.project-viewer-modal {
    border-radius: 5px;
    background: #000;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/project/components/ProProjectDetailsModal.vue